import { LeaguesUnion } from '../../types';
import Bronze from '../../assets/svg/leagues/bronze-league.svg';
import Challenger from '../../assets/svg/leagues/challanger-league.svg';
import Diamond from '../../assets/svg/leagues/diamond-league.svg';
import Gold from '../../assets/svg/leagues/gold-league.svg';
import Legendary from '../../assets/svg/leagues/legendary-league.svg';
import Master from '../../assets/svg/leagues/master-league.svg';
import Platinum from '../../assets/svg/leagues/platinum-league.svg';
import Silver from '../../assets/svg/leagues/silver-league.svg';

const className = 'w-[100%] h-[100%]';

const getLeagueIcon = (league: LeaguesUnion) => {
  switch (league) {
    case 'Bronze':
      return <img src={Bronze} alt="bronze-icon" className={className} />;
    case 'Silver':
      return <img src={Silver} alt="silver-icon" className={className} />;
    case 'Gold':
      return <img src={Gold} alt="gold-icon" className={className} />;
    case 'Platinum':
      return <img src={Platinum} alt="platinum-icon" className={className} />;
    case 'Diamond':
      return <img src={Diamond} alt="diamond-icon" className={className} />;
    case 'Challenger':
      return <img src={Challenger} alt="challenger-icon" className={className} />;
    case 'Legendary':
      return <img src={Legendary} alt="legendary-icon" className={className} />;
    case 'Master':
      return <img src={Master} alt="master-icon" className={className} />;
    default:
      return <img src={Bronze} alt="bronze-icon" className={className} />;
  }
};

export default getLeagueIcon;
